// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"1fb83e3c","863":"bc9d87d1"}[chunkId] + ".chunk.css";
};